import React, { useEffect, useRef, useState } from 'react'
import Layout from '../Components/Layouts/Layout';
import AnnouncementsForm from '../Components/EditAnnouncements/AnnouncementsForm';
import AutoEmailerForm from '../Components/AutoEmailer/AutoEmailerForm';

const AutoEmailer = () => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
     useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
  return (
    <>
        <Layout hideTopBar={true}>
            <section className='edit-announcements-wrap'>
                <div className='container'>
                    <AutoEmailerForm/>
                </div>
            </section>
        </Layout>
    </>
  )
}

export default AutoEmailer